import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { Thread } from 'styles/misc'
import { Title as TitleBase } from 'components/misc'

export const List = styled.dl`
  text-align: center;

  > div {
    ${mq.smallOnly} {
      margin: 1.4rem 0;
    }
  }

  dt,
  dd {
    display: block;
    margin: 0 auto;
  }

  dt {
    font-weight: 700;
  }

  ${mq.medium} {
    text-align: inherit;

    dt,
    dd {
      display: inline;
      margin: 0;
    }

    dd::before {
      content: ' – ';
    }
  }
`

export const Cols = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${mq.medium} {
    flex-direction: row;
    align-items: center;
  }
`

export const Title = styled(TitleBase)`
  ${mq.medium} {
    width: auto;
    margin-top: 15rem;

    &::before {
      ${Thread}
      left: 50%;
      bottom: -3rem;
      transform: translate(-50%, 0);
      width: 100%;
      aspect-ratio: 2070 / 281;
      mask-image: url("data:image/svg+xml,%3Csvg width='2070' height='281' viewBox='0 0 2073 281' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.219971 242.89C182.18 153.53 455.56 -5.42999 552.93 139.15C564.17 155.84 567.98 179.02 551.42 190.44C534.86 201.86 523.74 176.8 533.31 159.1C559.99 109.72 661.57 92.01 730.81 135.49C762.07 155.13 786.22 184.03 814.35 207.94C934.3 309.91 1131.92 303.1 1244.57 193.13C1257.2 180.8 1266.37 155.34 1249.72 149.46C1240.06 146.05 1230.02 154.32 1225.26 163.4C1207.37 197.54 1234.72 241.49 1270.94 254.64C1307.17 267.79 1347.36 258.88 1384.38 248.15C1463.69 225.15 1540.7 194.21 1613.87 155.94C1680.56 121.06 1757.38 78.99 1826.42 108.94C1846.12 117.48 1863.27 131.47 1883.57 138.47C1924.02 152.41 1970 135.4 2001.56 106.51C2033.12 77.62 2053.13 38.56 2072.15 0.230011' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
    }
  }
`
